import React, { useEffect } from 'react';
import Select, { Option } from '@ingka/select';
import { PostalCodeLocation } from '../services/State/model';
import { useStateDispatch } from '../store';
import {
  updateCityInSearch,
  updateCountryStateInSearch,
} from '../reducers/search/searchReducer';
import useTranslation from '../hooks/useTranslation';

interface LocationSelectorProps {
  locations: PostalCodeLocation[];
}

const LocationSelector: React.FC<LocationSelectorProps> = ({
  locations,
}): JSX.Element | null => {
  const { t } = useTranslation();
  const dispatch = useStateDispatch();

  const onSelectionChanged = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const locationIndex = parseInt(event.currentTarget.value, 10);
    const { state, city } = locations[locationIndex];
    dispatch(updateCountryStateInSearch(state));
    dispatch(updateCityInSearch(city || ''));
  };

  useEffect(() => {
    if (locations.length) {
      const { state, city } = locations[0];
      dispatch(updateCountryStateInSearch(state));
      dispatch(updateCityInSearch(city || ''));
    } else {
      dispatch(updateCountryStateInSearch(''));
      dispatch(updateCityInSearch(''));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locations]);

  return locations.length > 1 ? (
    <Select
      id="location"
      onChange={onSelectionChanged}
      hintText=""
      label={t('pages.start.state')}
    >
      {locations.map((location, index) => {
        const { city, state } = location;
        const combinedValues = city ? `${city}, ${state}` : state;
        return (
          <Option
            key={combinedValues}
            value={index.toString()}
            name={combinedValues}
          />
        );
      })}
    </Select>
  ) : null;
};

export default LocationSelector;
